import React from "react";
import { Link, Outlet, useOutletContext } from "react-router-dom";
import { MdOutlineBlock } from "react-icons/md";
import useModuleAccess from "../../hooks/useModuleAccess";
import { MODULES, hasModulePermission, isModuleAdmin, isModuleEnabled } from "../../constants/platformModules";

// Wraps the Finance / Dealership routes. The module must be switched on for the vendor
// (Super Admin), and a route can ask for the module admin or a permission set on top.
// The menu already hides what a person cannot use; this stops the same screens being
// reached by typing the URL. The API checks everything again on every request.
function Blocked({ title, text }) {
  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "60vh", color: "#6c757d", textAlign: "center", padding: 32 }}>
      <MdOutlineBlock size={48} style={{ marginBottom: 16, color: "#C9194A" }} />
      <h3 style={{ color: "#1a1a1a", marginBottom: 8 }}>{title}</h3>
      <p style={{ maxWidth: 380, fontSize: 14 }}>{text}</p>
      <Link to="/dashboard" className="btn btn-danger" style={{ borderRadius: 8, fontSize: 13, fontWeight: 600 }}>
        Back to Dashboard
      </Link>
    </div>
  );
}

// module: "FIN" | "DMS" (omit for screens every tenant user may open, e.g. the approvals inbox)
// admin: the module admin (owner, admin, FIN_CONTROLLER / DMS_ADMIN); permission: one or a list (any will do).
export function ModuleGate({ module, feature, admin, permission }) {
  const { access, loaded } = useModuleAccess();
  if (!loaded) return <div style={{ padding: 32, color: "#6c757d", fontSize: 14 }}>Loading…</div>;
  if (module) {
    const label = MODULES[module].label;
    if (!isModuleEnabled(access, module)) return <Blocked title={`${label} is not enabled`} text={`${label} has not been switched on for your account. Contact EzeitPro to enable it.`} />;
    if (feature && !isModuleEnabled(access, module, feature)) return <Blocked title="Not available" text={`This part of ${label} has not been switched on for your account. Contact EzeitPro to enable it.`} />;
    if (admin && !isModuleAdmin(access, module)) return <Blocked title="You do not have access" text={`Only the ${label} administrator can open this screen.`} />;
    const wanted = permission ? [].concat(permission) : [];
    if (wanted.length && !hasModulePermission(access, module, ...wanted)) return <Blocked title="You do not have access" text={`Ask your ${label} administrator to give you access to this screen.`} />;
  }
  return <Outlet context={{ access }} />;
}

// What the module screens read from the gate.
export const useModule = () => useOutletContext();

export default ModuleGate;
